import { DeathAnscNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import PersonSearchDeathNonResidentNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchDeathNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchDeathNonResidentNotificationCivilStatusShared
        scope={IdAmbito.Iscrizioni}
        items={DeathAnscNotificationsNonResidentSubscriptionCrumbs()}
      />
    </Fragment>
  );
};

PersonSearchDeathNonResidentNotificationCivilStatusPage.displayName =
  'Research Death Non Resident Notifications Page component';

export default PersonSearchDeathNonResidentNotificationCivilStatusPage;
